export enum TypeFilesEnum {
    additionLead = 'additionLead',
}